export default __webpack_public_path__ + "static/media/volume-medium.c34a6f61.svg";